var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#E8ECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5266 34.6994C47.5266 35.5525 46.8563 36.1619 46.0641 36.1619H36.3141V45.9119C36.3141 46.765 35.6437 47.4354 34.8516 47.4354C33.9984 47.4354 33.3891 46.765 33.3891 45.9119V36.1619H23.6391C22.7859 36.1619 22.1766 35.5525 22.1766 34.7604C22.1766 33.9072 22.7859 33.2369 23.6391 33.2369H33.3891V23.4869C33.3891 22.6947 33.9984 22.0854 34.8516 22.0854C35.6437 22.0854 36.3141 22.6947 36.3141 23.4869V33.2369H46.0641C46.8563 33.2369 47.5266 33.9072 47.5266 34.6994Z",
    fill: "#25272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleIcon);
export default __webpack_public_path__ + "static/media/plusCircleIcon.13b229e1124da7a858b86f01f57ea2bc.svg";
export { ForwardRef as ReactComponent };